import { instance, objectToParams } from '../api';

/**
 * Informe de valoración de existencias (tabla dinámica).
 * Contrato: `mirtomex-back/__APIDOC__/api/v1/reports/stocks/GET.md`.
 */
export const getReportsStocks = (args) => instance.get(`/api/v1/reports/stocks?${objectToParams(args)}`);

export const getReportsStocksViewPdf = (args) =>
  instance.get(`/api/v1/reports/stocks/view/pdf?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsStocksFullPdf = (args) =>
  instance.get(`/api/v1/reports/stocks/full/pdf?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsStocksExcel = (args) =>
  instance.get(`/api/v1/reports/stocks/excel?${objectToParams(args)}`, { responseType: 'blob' });
